import Inquiry from 'app/shared/model/Inquiry';
import Listing from 'app/shared/model/Listing';
import Pager from 'app/shared/model/Pager';

const LeadsForListing = ({
    excelFilename = '',
    inquiries = [],
    listing = {},
    pager = {},
    phoneCallsByGuid = {},
} = {}) => ({
    excelFilename: String(excelFilename),
    inquiries: inquiries.map(item => Inquiry(item)),
    listing: Listing(listing),
    pager: Pager(pager),
    phoneCallsByGuid: Object(phoneCallsByGuid),
});

export default LeadsForListing;
